import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=344caf62&scoped=true"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"
import style0 from "./Buttons.vue?vue&type=style&index=0&id=344caf62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344caf62",
  null
  
)

export default component.exports